export const ORG_IDS = {
  SELEGO: "62961be126ff569dbb11d3e6",
  LE_COLLECTIF: "645131208989391af9bc9e33",
};

export const BANK_SOURCE_TO_ORG = {
  BNP: ORG_IDS.LE_COLLECTIF,
  BUNQ: ORG_IDS.SELEGO,
};
